export const config = {
  state: process.env.REACT_APP_HOST_ENV || "PROD",
  prodJavaURL: "https://fex-prod.aakash.ac.in/Prod/java/8090/fms/",
  prodJavaURLCMS: "https://lcmsapi-prod.aakash.ac.in/Prod/java/8080/",
  stagingJavaURL: "https://lcmsapi-stage.aakash.ac.in/stage/java/8090/fms/",
  stagingJavaURLCMS: "https://lcmsapi-stage.aakash.ac.in/stage/java/8080/",
  app_id: "aakash_edu_46177f",
  app_key: "3c61bd75069a1893e8a0",
  devJavaURLCMS: "https://lcmsapi-dev.aakash.ac.in/dev/java/8080/",
  devJavaURL: "https://lcmsapi-dev.aakash.ac.in/dev/java/8090/fms/",
  stagingS3: "https://content-staging-aakash.s3.ap-south-1.amazonaws.com/",
  devS3: "https://content-staging-aakash.s3.ap-south-1.amazonaws.com/",
  prodS3: "https://fms-fex-content-aakash-prod.s3.ap-south-1.amazonaws.com/",
  devSSO: "https://lcmsapi-dev.aakash.ac.in/dev/java/8087/",
  stagingSSO: "https://lcmsapi-stage.aakash.ac.in/stage/java/8087/",
  prodSSO: "https://lcmsapi-prod.aakash.ac.in/Prod/java/8087/",
  aakashLogo: "https://d3vo8rtp78h2dc.cloudfront.net/Media/AakashMainLogo.png",
  cdnUrl: "https://d29zr2abydv3bb.cloudfront.net",
  prodcdnUrl: "https://d3vo8rtp78h2dc.cloudfront.net",
  notificationPublicKey:
    "BDjDLT9rIJU4pBsK4mMH1bVQerwSoj8qV9XRN8wAY3pS1SkJjUFVzx_qjztD4mipMU7alf1KuV84eHfznJEA63k",
};
